import AccessAndAccounts from "./AccessAndAccounts";
import { logout, fetchStudioSummary } from "../api/client";
import StudioCockpit from "./StudioCockpit";
import { useEffect, useState } from "react";
import { computeProfileCompletion } from "../profileCompletion";
import useStudioApplications from "../useStudioApplications";

export default function OwnerMembershipConsole({ user }) {
  const [summary, setSummary] = useState(null);
  const { applications, applicationsError, applicationsStale, applicationsLoading } = useStudioApplications(Boolean(user));
  const [summaryRefreshedAt, setSummaryRefreshedAt] = useState(null);
  const [summaryError, setSummaryError] = useState("");
  const [summaryAttemptAt, setSummaryAttemptAt] = useState(null);
  const [authError, setAuthError] = useState("");
  const profileSummary = computeProfileCompletion(user);
  const profileDisplayName = user?.display_name || user?.username || "Studio owner";
  const profileInitials = profileDisplayName.split(/\s+/).filter(Boolean).map((part) => part[0]).join("").toUpperCase().slice(0, 2) || "H";
  useEffect(() => {
    let active = true;
    const refresh = async () => {
      const next = await fetchStudioSummary();
      if (active) setSummaryAttemptAt(new Date());
      if (active && next) { setSummary(next); setSummaryRefreshedAt(new Date()); setSummaryError(""); }
      else if (active) setSummaryError("Studio state is temporarily unavailable. Membership review remains available.");
    };
    refresh();
    const interval = window.setInterval(refresh, 15000);
    return () => { active = false; window.clearInterval(interval); };
  }, []);
  const signOut = async () => {
    setAuthError("");
    try {
      const result = await logout();
      if (!result?.success) {
        setAuthError("Could not sign out. Please try again.");
        return;
      }
      window.location.href = "/";
    } catch {
      setAuthError("Could not sign out. Please try again.");
    }
  };
  return (
    <main className="studio-console iam-owner-console">
      <header className="studio-header">
        <div><div className="studio-eyebrow">STUDIO OWNER</div><h1 className="studio-title">Membership review</h1>
          <p className="studio-subtitle">{user?.display_name || user?.username} · signup requests for your studio</p></div>
      </header>
      {authError && <div className="studio-alert studio-alert-attention" role="alert">{authError}</div>}
      {summaryError && <div className="studio-alert studio-alert-attention" role="status">{summaryError} <button className="studio-btn-ghost" type="button" onClick={signOut}>Sign out</button></div>}
      {!summary && !summaryError && <p className="studio-muted">Loading studio overview…</p>}
      {summary && <StudioCockpit
        user={user}
        profileDisplayName={profileDisplayName}
        profileInitials={profileInitials}
        profileCompletion={profileSummary.available ? `${profileSummary.percent}% · ${profileSummary.label}` : "Profile details unavailable"}
        onEditProfile={() => { window.location.href = "/profile"; }}
        onSignOut={signOut}
        summary={summary}
        refreshError={summaryError || applicationsError}
        applications={applications}
        applicationsStale={applicationsStale}
        applicationsLoading={applicationsLoading}
        stale={!summaryRefreshedAt || Date.now() - summaryRefreshedAt.getTime() > 45000}
        lastRefreshedAt={summaryRefreshedAt}
        lastAttemptAt={summaryAttemptAt}
        eventState={summary.class?.state || "UNKNOWN"}
        dominantState={summary.class?.state || "NO CLASS"}
        readiness={summary.readiness || {}}
        incidents={summary.incidents || []}
        cls={summary.class || {}}
        schedule={summary.schedule || []}
        ownerMode
      />}
      <details id="owner-membership" className="studio-legacy-workflows"><summary>Membership &amp; signup requests</summary><AccessAndAccounts /></details>
    </main>
  );
}
